import * as React from 'react'
import { IconButton } from '@doordash/component-button'
import {
  ANDROID_CLOSE_DEEPLINK,
  IOS_CLOSE_DEEPLINK,
} from '../../../constants'
import { OsTypes } from '../../../webview/types'
import { detectWebviewOs } from '../../../utilities/userAgent'
import { OnboardingComponentProps } from '.'

export const CloseIconButtonComponent: React.FC<OnboardingComponentProps> = (props) => {
  const onClick = () => {
    props.trackWorkflowEvent({
      event: props.eventInfo.event,
      name: props.eventInfo.name,
      action: props.eventInfo.action
    })
    window.location.assign(
      os === OsTypes.iOS ? IOS_CLOSE_DEEPLINK : ANDROID_CLOSE_DEEPLINK
    )
  }
  const os = detectWebviewOs()
  return (
    <IconButton
      size={IconButton.Sizes.XxxSmall}
      accessibilityLabel= 'closeButton'
      iconType={IconButton.IconTypes.Close}
      onClick={onClick}
      />
  
  )
}